enum LoadingStatus {
    Initial = "initial",
    Ready = "ready",
    Loading = "loading",
    Saving = "saving",
    Complete = "ready"
}

export default LoadingStatus
